import { kExternalStorageProviderDisplayName, type ExternalStorageProvider } from '@/constants/constants-external-storage'
import { kPaxtonName } from '@/constants/constants-strings'

type ExternalStorageLinkedItem = {
  external_storage?: {
    provider: ExternalStorageProvider
    tombstoned: boolean
  } | null
}

/**
 * Which drive a search result lives in — the first segment of its location.
 *
 * Results span both sources, so two folders of the same name in different drives are otherwise
 * indistinguishable. The segment is only worth showing to someone who actually has a drive
 * connected; without one, everything is ours and naming that adds nothing (Jennifer,
 * #project-files 2026-08-10).
 *
 * @param hasSyncedDrive - Whether this matter has an active sync mapping
 */
export function getSourceRootLabel(item: ExternalStorageLinkedItem, hasSyncedDrive: boolean): string | null {
  if (!hasSyncedDrive) return null

  const provider = item.external_storage?.provider

  return provider ? kExternalStorageProviderDisplayName[provider] : kPaxtonName
}
